module.exports = __webpack_public_path__ + "static/media/lazienka.bda4fc86.jpg";